import { Input as BaseInput, InputProps, useInput } from "@mui/base";
import clsx from "clsx";
import React, { useEffect, useImperativeHandle } from "react";

import styles from "./Input.module.scss";

const Input = React.forwardRef(function CustomButton(
  props: InputProps & {
    errormessage?: string;
    radioLabel?: string;
    ownProps?: { noErrors?: boolean };
    value?: string;
    errorClassName?: string;
    wrapperClassName?: string;
    isSecret?: boolean;
  },
  ref: React.ForwardedRef<HTMLInputElement>,
) {
  const {
    disabled,
    errormessage,
    value,
    radioLabel,
    readOnly,
    errorClassName,
    wrapperClassName,
    ownProps,
    slots,
    isSecret,
    ...other
  } = props;
  const { getRootProps } = useInput({ ...props });

  const inputId =
    props.id ||
    (props.type === "radio" && radioLabel
      ? radioLabel.replace(/\s+/g, "-").toLowerCase()
      : undefined);

  const inputRef = React.useRef<HTMLInputElement | null>(null);
  useImperativeHandle(ref, () => inputRef.current as HTMLInputElement);

  const [isHidden, setIsHidden] = React.useState<boolean>(!!isSecret);

  useEffect(() => {
    if (isSecret) {
      setIsHidden(true);
    }
  }, [isSecret]);

  return (
    <div
      className={clsx(styles.baseInputWrapper, wrapperClassName, {
        [styles.radio]: props.type === "radio",
      })}
    >
      <BaseInput
        {...getRootProps()}
        id={inputId}
        className={clsx(styles.input, {
          [styles.error]: errormessage,
          [styles.disabled]: disabled,
          [styles.readOnly]: readOnly, // Add the readOnly class
        })}
        slots={{
          root: "div",
          input: "input",
          ...slots,
        }}
        slotProps={{
          input: {
            ref: inputRef,
          },
        }}
        {...other}
        ref={ref}
        value={
          isSecret && isHidden && typeof value === "string"
            ? "•".repeat(value.length)
            : value
        }
      />

      {isSecret && (
        <button
          type="button"
          onClick={() => setIsHidden((prev) => !prev)}
          className={styles.secretToggle}
        >
          {isHidden ? "View" : "Hide"}
        </button>
      )}

      {radioLabel && (
        // @ts-expect-error TS2339 non-existing className
        <label htmlFor={inputId} className={styles.radioLabel}>
          {radioLabel}
        </label>
      )}
      {!ownProps?.noErrors && errormessage && (
        <div className={clsx(styles.errorMessage, errorClassName)}>
          {errormessage}
        </div>
      )}
    </div>
  );
});

export default Input;
